import {Injectable} from '@angular/core';
import {InfoService} from '../section-service.class';
import {Service} from '../../common/service.class';
import {Observable} from 'rxjs';

/**
 * Created by Rodrigo Quesada on 15/03/17.
 */
@Injectable()
export class ClientInfoService extends InfoService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'client');
    }

    getIp(): Observable<string> { return this.getScalarValue('ip'); }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/client/client-info.service.ts